"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ref = void 0;
/**
 * A class to enable functions to pass parameters by reference
 *
 */
class ref {
    value;
}
exports.ref = ref;
//# sourceMappingURL=ref.js.map